import type { HTMLAttributes } from "react";

import { cn } from "@/lib/utils";

/** Minimal shadcn-style skeleton. Pulse animation, no ornamentation. */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted/50", className)}
      {...props}
    />
  );
}
